<template>
  <div id="app-switch">

    <h1>Choose a client</h1>

    <ul>
      <li v-for="item in $store.getters.user.scopes" :value="item.slug" @click="choose(item.slug)">
        <div class="parent-logo" v-bind:style="{background:$store.getters.scopes[item.parent_id].color}" v-if="item.parent_id && $store.getters.scopes[item.parent_id]">
          <img :src="$store.getters.scopes[item.parent_id].picture.url+'/fit/100x100'" v-if="$store.getters.scopes[item.parent_id].picture">
          <span v-if="!$store.getters.scopes[item.parent_id].picture">{{ $store.getters.scopes[item.parent_id].slug.substr(0,1) }}</span>
        </div>
        <div class="logo" v-bind:style="{background:item.color}">
          <img :src="item.picture.url+'/fit/100x100'" v-if="item.picture">
          <span v-if="!item.picture">{{ item.slug.substr(0,1) }}</span>
        </div>
        <span class="name">{{ item.name }}</span>
      </li>
    </ul>

  </div>
</template>

<script>
    export default {
        name: 'switch',
        data() {
            return {
            }
        },
        mounted: function(){

        },
        methods: {
            choose(slug) {
                this.$store.dispatch("switchScope", slug).then(() => {
                    this.$router.push("/dashboard")
                });
            }
        }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Switch.vue